import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import Row from '@sdk/components/ui/spacing/Row';

export const ArticleBox = styled.article`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2px;
`;

export const ArticleWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 30px 20px;
`;

export const LikesAndCommentsWrapper = styled(Row)`
  align-items: center;
  gap: 10px;
`;

type FooterTextProps = {
  highlighted?: boolean;
  clickable?: boolean;
};

export const FooterText = styled(Text12)<FooterTextProps>`
  transition: color 0.3s ease;
  color: ${(props) =>
    props.highlighted ? props.theme.colors.primary : props.theme.colors.iconGray};

  &:hover {
    ${(props) =>
      props.clickable
        ? `
        color: ${props.theme.colors.primary}; 
        cursor: pointer;`
        : ''};
  }
`;

export const IconWithCounterWrapper = styled.span`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
